module.exports = __webpack_public_path__ + "static/img/mtndjg.f0708ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mtndjg.jpg
// module id = 15rD
// module chunks = 1